import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('show-next-steps-on-vsa-performance-page');
	},
};
